(() => {
  if (window.__discountProgressStoreCurrencyInit__) return;
  window.__discountProgressStoreCurrencyInit__ = true;

  let updateTimer = null;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number === null) {
      return '0';
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + thousands
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }

    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    const formatString = format || '${{amount}}';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const match = formatString.match(placeholderRegex);
    const placeholder = match ? match[1] : 'amount';
    let value = '';

    switch (placeholder) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', '.');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function renderMoneyNode(el, leftMinor, moneyFormat) {
    const wrap = el.querySelector('[data-left-wrap]');
    if (!wrap) return;

    wrap.innerHTML = `<span class="money" data-left>${formatMoney(leftMinor, moneyFormat)}</span>`;
  }

  function moneyNodeReady(el) {
    const wrap = el.querySelector('[data-left-wrap]');
    if (!wrap) return true;

    const text = (wrap.textContent || '').trim();

    if (text.includes('<span') || text.includes('</span')) {
      return false;
    }

    if (wrap.querySelector('.glc-money')) {
      return true;
    }

    if (wrap.querySelector('.money')) {
      return true;
    }

    return /\d/.test(text);
  }

  function queueReveal(el) {
    if (el._discountProgressRevealTimer) {
      clearTimeout(el._discountProgressRevealTimer);
    }

    el.dataset.jsReady = '0';

    let tries = 0;
    const maxTries = 30;
    const delay = 80;

    function check() {
      tries += 1;

      if (moneyNodeReady(el) || tries >= maxTries) {
        el.dataset.jsReady = '1';
        return;
      }

      el._discountProgressRevealTimer = setTimeout(check, delay);
    }

    check();
  }

  function updateOne(el) {
    const thresholdMinor = parseInt(el.dataset.thresholdShopMinor || '0', 10) || 0;
    const cartTotalMinor = parseInt(el.dataset.cartTotalMinor || '0', 10) || 0;
    const moneyFormat = el.dataset.moneyFormat || '${{amount}}';

    const leftMinor = Math.max(thresholdMinor - cartTotalMinor, 0);
    const pct = thresholdMinor > 0
      ? Math.min(100, (cartTotalMinor / thresholdMinor) * 100)
      : 100;

    renderMoneyNode(el, leftMinor, moneyFormat);

    const bar = el.querySelector('[data-bar]');
    if (bar) {
      bar.style.width = pct + '%';
    }

    const notice = el.querySelector('[data-notice]');
    const success = el.querySelector('[data-success]');
    if (notice && success) {
      if (leftMinor > 0) {
        notice.style.display = '';
        success.style.display = 'none';
      } else {
        notice.style.display = 'none';
        success.style.display = '';
      }
    }

    const icon = el.querySelector('[data-icon]');
    if (icon) {
      icon.classList.toggle('iconicion', leftMinor <= 0);
    }

    queueReveal(el);
  }

  function updateAll(root = document) {
    root.querySelectorAll('[data-discount-progress]').forEach(updateOne);
  }

  function scheduleUpdate(root = document) {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(() => updateAll(root), 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateAll());
  } else {
    updateAll();
  }

  const mo = new MutationObserver((muts) => {
    let shouldRefresh = false;

    for (const m of muts) {
      if (!m.addedNodes) continue;

      m.addedNodes.forEach((n) => {
        if (!(n instanceof Element)) return;

        if (n.matches?.('[data-discount-progress]')) {
          updateOne(n);
        }

        n.querySelectorAll?.('[data-discount-progress]').forEach(updateOne);

        if (
          n.id === 'AjaxCartForm' ||
          n.querySelector?.('#AjaxCartForm') ||
          n.id === 'AjaxCartSubtotal' ||
          n.querySelector?.('#AjaxCartSubtotal')
        ) {
          shouldRefresh = true;
        }
      });
    }

    if (shouldRefresh) {
      scheduleUpdate();
    }
  });

  mo.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('shopify:section:load', () => scheduleUpdate());
  document.addEventListener('cart-updated', () => scheduleUpdate());
  document.addEventListener('cart:updated', () => scheduleUpdate());
  document.addEventListener('cart:refresh', () => scheduleUpdate());
  document.addEventListener('cart:change', () => scheduleUpdate());

  [150, 500, 1200, 2000].forEach((delay) => {
    setTimeout(() => scheduleUpdate(), delay);
  });
})();